import { Model } from "@/lib/types"


export const models: Record<ModelId, Model> = {
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // PERPLEXITY 
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "perplexity/sonar": {
        "id": "perplexity/sonar",
        "providerModelId": "sonar",
        "name": "Sonar",
        "provider": "perplexity",
        "maker": "Perplexity",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Other",
            "contextLength": 127072,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 0.000001,
            "output_token": 0.000001,
            "request": 0.005
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Sonar is lightweight, affordable, fast, and simple to use — now featuring citations and the ability to customize sources. It is designed for companies seeking to integrate lightweight question-and-answer features optimized for speed.",
            "releaseDate": "2025-01-27",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "perplexity/sonar"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "web_search_options",
                "top_k",
                "frequency_penalty",
                "presence_penalty"
            ],
            "modelParameters": []
        }
    },

    "perplexity/sonar-pro": {
        "id": "perplexity/sonar-pro",
        "providerModelId": "sonar-pro",
        "name": "Sonar Pro",
        "provider": "perplexity",
        "maker": "Perplexity",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Other",
            "contextLength": 200000,
            "maxCompletionTokens": 8000
        },
        "pricing": {
            "input_token": 0.000003,
            "output_token": 0.000015,
            "output_websearch": 0.005
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Note: Sonar Pro pricing includes Perplexity search pricing. See [details here](https://docs.perplexity.ai/guides/pricing#detailed-pricing-breakdown-for-sonar-reasoning-pro-and-sonar-pro)\n\nFor enterprises seeking more advanced capabilities, the Sonar Pro API can handle in-depth, multi-step queries with added extensibility, like double the number of citations per search as Sonar on average. Plus, with a larger context window, it can handle longer and more nuanced searches and follow-up questions. ",
            "releaseDate": "2025-03-07",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "perplexity/sonar-pro"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "web_search_options",
                "top_k",
                "frequency_penalty",
                "presence_penalty"
            ],
            "modelParameters": []
        }
    },



    "perplexity/sonar-reasoning-pro": {
        "id": "perplexity/sonar-reasoning-pro",
        "providerModelId": "sonar-reasoning-pro",
        "name": "Sonar Reasoning Pro",
        "provider": "perplexity",
        "maker": "Perplexity",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Other",
            "contextLength": 128000,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 0.000002,
            "output_token": 0.000008,
            "output_websearch": 0.005
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Note: Sonar Pro pricing includes Perplexity search pricing. See [details here](https://docs.perplexity.ai/guides/pricing#detailed-pricing-breakdown-for-sonar-reasoning-pro-and-sonar-pro)\n\nSonar Reasoning Pro is a premier reasoning model powered by DeepSeek R1 with Chain of Thought (CoT). Designed for advanced use cases, it supports in-depth, multi-step queries with a larger context window and can surface more citations per search, enabling more comprehensive and extensible responses.",
            "releaseDate": "2025-03-07",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "perplexity/sonar-reasoning-pro"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "reasoning",
                "include_reasoning",
                "web_search_options",
                "top_k",
                "frequency_penalty",
                "presence_penalty"
            ],
            "modelParameters": []
        }
    },



    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // ANTHROPIC 
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "openrouter:anthropic/claude-sonnet-4": {
        "id": "openrouter:anthropic/claude-sonnet-4",
        "providerModelId": "anthropic/claude-sonnet-4",
        "name": "Claude Sonnet 4",
        "provider": "openrouter",
        "maker": "Anthropic",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "Claude",
            "contextLength": 200000,
            "maxCompletionTokens": 64000
        },
        "pricing": {
            "input_token": 0.000003,
            "input_image": 0.0048,
            "output_token": 0.000015
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true
        },
        "metadata": {
            "description": "Claude Sonnet 4 significantly enhances the capabilities of its predecessor, Sonnet 3.7, excelling in both coding and reasoning tasks with improved precision and controllability. Achieving state-of-the-art performance on SWE-bench (72.7%), Sonnet 4 balances capability and computational efficiency, making it suitable for a broad range of applications from routine coding tasks to complex software development projects. Key enhancements include improved autonomous codebase navigation, reduced error rates in agent-driven workflows, and increased reliability in following intricate instructions. Sonnet 4 is optimized for practical everyday use, providing advanced reasoning capabilities while maintaining efficiency and responsiveness in diverse internal and external scenarios.\n\nRead more at the [blog post here](https://www.anthropic.com/news/claude-4)",
            "releaseDate": "2025-05-22",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "anthropic/claude-4-sonnet-20250522"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "stop",
                "reasoning",
                "include_reasoning",
                "tools",
                "tool_choice",
                "top_p",
                "top_k"
            ],
            "modelParameters": []
        }
    },
    "openrouter:anthropic/claude-opus-4": {
        "id": "openrouter:anthropic/claude-opus-4",
        "providerModelId": "anthropic/claude-opus-4",
        "name": "Claude Opus 4",
        "provider": "openrouter",
        "maker": "Anthropic",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "Claude",
            "contextLength": 200000,
            "maxCompletionTokens": 32000
        },
        "pricing": {
            "input_token": 0.000015,
            "input_image": 0.024,
            "output_token": 0.000075
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "Claude Opus 4 is benchmarked as the world’s best coding model, at time of release, bringing sustained performance on complex, long-running tasks and agent workflows. It sets new benchmarks in software engineering, achieving leading results on SWE-bench (72.5%) and Terminal-bench (43.2%). Opus 4 supports extended, agentic workflows, handling thousands of task steps continuously for hours without degradation. \n\nRead more at the [blog post here](https://www.anthropic.com/news/claude-4)",
            "releaseDate": "2025-05-22",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "anthropic/claude-4-opus-20250522"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "stop",
                "reasoning",
                "include_reasoning",
                "tools",
                "tool_choice",
                "top_p",
                "top_k"
            ],
            "modelParameters": []
        }
    },



    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // GOOGLE
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "openrouter:google/gemini-2.0-flash-001": {
        "id": "openrouter:google/gemini-2.0-flash-001",
        "providerModelId": "google/gemini-2.0-flash-001",
        "name": "Gemini 2.0 Flash",
        "provider": "openrouter",
        "maker": "Google",
        "active": false,
        "status": "deprecated",
        "fallbackModelId": "openrouter:google/gemini-2.5-flash-lite",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Gemini",
            "contextLength": 1048576,
            "maxCompletionTokens": 8192
        },
        "pricing": {
            "input_token": 1e-7,
            "input_image": 0.0000258,
            "output_token": 4e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true
        },
        "metadata": {
            "description": "Gemini Flash 2.0 offers a significantly faster time to first token (TTFT) compared to [Gemini Flash 1.5](/google/gemini-flash-1.5), while maintaining quality on par with larger models like [Gemini Pro 1.5](/google/gemini-pro-1.5). It introduces notable enhancements in multimodal understanding, coding capabilities, complex instruction following, and function calling. These advancements come together to deliver more seamless and robust agentic experiences.",
            "releaseDate": "2025-02-05",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "google/gemini-2.0-flash-001"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "stop",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:google/gemini-2.5-flash-lite": {
        "id": "openrouter:google/gemini-2.5-flash-lite",
        "providerModelId": "google/gemini-2.5-flash-lite",
        "name": "Gemini 2.5 Flash Lite",
        "provider": "openrouter",
        "maker": "Google",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Gemini",
            "contextLength": 1048576,
            "maxCompletionTokens": 65535
        },
        "pricing": {
            "input_token": 1e-7,
            "output_token": 4e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true
        },
        "metadata": {
            "description": "Gemini 2.5 Flash-Lite is a lightweight reasoning model in the Gemini 2.5 family, optimized for ultra-low latency and cost efficiency. It offers improved throughput, faster token generation, and better performance across common benchmarks compared to earlier Flash models. By default, \"thinking\" (i.e. multi-pass reasoning) is disabled to prioritize speed, but developers can enable it via the [Reasoning API parameter](https://openrouter.ai/docs/use-cases/reasoning-tokens) to selectively trade off cost for intelligence. ",
            "releaseDate": "2025-07-22",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "google/gemini-2.5-flash-lite"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "reasoning",
                "include_reasoning",
                "structured_outputs",
                "response_format",
                "seed"
            ],
            "modelParameters": []
        }
    },
    "openrouter:google/gemini-2.5-flash": {
        "id": "openrouter:google/gemini-2.5-flash",
        "providerModelId": "google/gemini-2.5-flash",
        "name": "Gemini 2.5 Flash",
        "provider": "openrouter",
        "maker": "Google",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Gemini",
            "contextLength": 1048576,
            "maxCompletionTokens": 65535
        },
        "pricing": {
            "input_token": 3e-7,
            "input_image": 0.001238,
            "output_token": 0.0000025
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true
        },
        "metadata": {
            "description": "Gemini 2.5 Flash is Google's state-of-the-art workhorse model, specifically designed for advanced reasoning, coding, mathematics, and scientific tasks. It includes built-in \"thinking\" capabilities, enabling it to provide responses with greater accuracy and nuanced context handling. \n\nAdditionally, Gemini 2.5 Flash is configurable through the \"max tokens for reasoning\" parameter, as described in the documentation (https://openrouter.ai/docs/use-cases/reasoning-tokens#max-tokens-for-reasoning).",
            "releaseDate": "2025-06-17",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "google/gemini-2.5-flash"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "reasoning",
                "include_reasoning",
                "structured_outputs",
                "response_format",
                "stop"
            ],
            "modelParameters": []
        }
    },
    "openrouter:google/gemini-2.5-pro": {
        "id": "openrouter:google/gemini-2.5-pro",
        "providerModelId": "google/gemini-2.5-pro",
        "name": "Gemini 2.5 Pro",
        "provider": "openrouter",
        "maker": "Google",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Gemini",
            "contextLength": 1048576,
            "maxCompletionTokens": 65536
        },
        "pricing": {
            "input_token": 0.00000125,
            "input_image": 0.00516,
            "output_token": 0.00001
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true
        },
        "metadata": {
            "description": "Gemini 2.5 Pro is Google’s state-of-the-art AI model designed for advanced reasoning, coding, mathematics, and scientific tasks. It employs “thinking” capabilities, enabling it to reason through responses with enhanced accuracy and nuanced context handling. Gemini 2.5 Pro achieves top-tier performance on multiple benchmarks, including first-place positioning on the LMArena leaderboard, reflecting superior human-preference alignment and complex problem-solving abilities.",
            "releaseDate": "2025-06-17",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "google/gemini-2.5-pro"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "reasoning",
                "include_reasoning",
                "structured_outputs",
                "response_format",
                "stop"
            ],
            "modelParameters": []
        }
    },

    // Imagen 4 via fal.ai
    "fal-ai/imagen4/preview": {
        "id": "fal-ai/imagen4/preview",
        "providerModelId": "fal-ai/imagen4/preview",
        "name": "Imagen 4",
        "provider": "fal",
        "maker": "Google",
        "active": true,
        "status": "preview",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "image"
            ],
            "capabilities": [
                "image"
            ],
            "tokenizer": "Other",
            "contextLength": null,
            "maxCompletionTokens": null
        },
        "pricing": {
            "output_image": 0.04
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true,
            "imageOperations": ["create"]
        },
        "metadata": {
            "description": "Google’s highest quality image generation model.",
            "releaseDate": null,
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "fal-ai/imagen4/preview"
        },
        "parameters": {
            "openrouterSupportedParameters": [],
            "modelParameters": []
        }
    },

    // FLUX.1 Kontext [max] via fal.ai (image-to-image)
    "fal-ai/flux-pro/kontext/max": {
        "id": "fal-ai/flux-pro/kontext/max",
        "providerModelId": "fal-ai/flux-pro/kontext/max",
        "name": "FLUX.1 Kontext [max]",
        "provider": "fal",
        "maker": "black forest labs",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "image"
            ],
            "capabilities": [
                "image"
            ],
            "tokenizer": "Other",
            "contextLength": null,
            "maxCompletionTokens": null
        },
        "pricing": {
            "output_image": 0.08
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": true,
            "imageOperations": ["edit"]
        },
        "metadata": {
            "description": "FLUX.1 Kontext [max] with improved prompt adherence and typography for editing; premium consistency for image-to-image.",
            "releaseDate": null,
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "fal-ai/flux-pro/kontext/max",
            "predictionTimeSecond": 8
        },
        "parameters": {
            "openrouterSupportedParameters": [],
            "modelParameters": []
        }
    },



    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // OPENAI
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "openrouter:openai/gpt-4.1-nano": {
        "id": "openrouter:openai/gpt-4.1-nano",
        "providerModelId": "openai/gpt-4.1-nano",
        "name": "GPT-4.1 Nano",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": false,
        "status": "deprecated",
        "fallbackModelId": "openrouter:openai/gpt-5-nano",
        "architecture": {
            "inputModalities": [
                "image",
                "text",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 1047576,
            "maxCompletionTokens": 32768
        },
        "pricing": {
            "input_token": 1e-7,
            "output_token": 4e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "For tasks that demand low latency, GPT‑4.1 nano is the fastest and cheapest model in the GPT-4.1 series. It delivers exceptional performance at a small size with its 1 million token context window, and scores 80.1% on MMLU, 50.3% on GPQA, and 9.8% on Aider polyglot coding – even higher than GPT‑4o mini. It’s ideal for tasks like classification or autocompletion.",
            "releaseDate": "2025-04-14",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-4.1-nano-2025-04-14"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "seed",
                "logit_bias",
                "logprobs",
                "top_logprobs",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/gpt-4.1-mini": {
        "id": "openrouter:openai/gpt-4.1-mini",
        "providerModelId": "openai/gpt-4.1-mini",
        "name": "GPT-4.1 Mini",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": false,
        "status": "deprecated",
        "fallbackModelId": "openrouter:openai/gpt-5-mini",
        "architecture": {
            "inputModalities": [
                "image",
                "text",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 1047576,
            "maxCompletionTokens": 32768
        },
        "pricing": {
            "input_token": 4e-7,
            "output_token": 0.0000016
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "GPT-4.1 Mini is a mid-sized model delivering performance competitive with GPT-4o at substantially lower latency and cost. It retains a 1 million token context window and scores 45.1% on hard instruction evals, 35.8% on MultiChallenge, and 84.1% on IFEval. Mini also shows strong coding ability (e.g., 31.6% on Aider’s polyglot diff benchmark) and vision understanding, making it suitable for interactive applications with tight performance constraints.",
            "releaseDate": "2025-04-14",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-4.1-mini-2025-04-14"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "web_search_options",
                "seed",
                "logit_bias",
                "logprobs",
                "top_logprobs",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/gpt-4.1": {
        "id": "openrouter:openai/gpt-4.1",
        "providerModelId": "openai/gpt-4.1",
        "name": "GPT-4.1",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": false,
        "status": "deprecated",
        "fallbackModelId": "openrouter:openai/gpt-5",
        "architecture": {
            "inputModalities": [
                "image",
                "text",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 1047576,
            "maxCompletionTokens": 32768
        },
        "pricing": {
            "input_token": 0.000002,
            "output_token": 0.000008
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "GPT-4.1 is a flagship large language model optimized for advanced instruction following, real-world software engineering, and long-context reasoning. It supports a 1 million token context window and outperforms GPT-4o and GPT-4.5 across coding (54.6% SWE-bench Verified), instruction compliance (87.4% IFEval), and multimodal understanding benchmarks. It is tuned for precise code diffs, agent reliability, and high recall in large document contexts, making it ideal for agents, IDE tooling, and enterprise knowledge retrieval.",
            "releaseDate": "2025-04-14",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-4.1-2025-04-14"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "web_search_options",
                "seed",
                "logit_bias",
                "logprobs",
                "top_logprobs",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/gpt-4o": {
        "id": "openrouter:openai/gpt-4o",
        "providerModelId": "openai/chatgpt-4o-latest",
        "name": "GPT-4o",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 128000,
            "maxCompletionTokens": 16384
        },
        "pricing": {
            "input_token": 0.0000025,
            "input_image": 0.003613,
            "output_token": 0.00001
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "OpenAI ChatGPT 4o is continually updated by OpenAI to point to the current version of GPT-4o used by ChatGPT.",
            "releaseDate": "2024-05-13",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-4o"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "tools",
                "tool_choice",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "web_search_options",
                "seed",
                "logit_bias",
                "logprobs",
                "top_logprobs",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/o3": {
        "id": "openrouter:openai/o3",
        "providerModelId": "openai/o3",
        "name": "o3",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "image",
                "text",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 200000,
            "maxCompletionTokens": 100000
        },
        "pricing": {
            "input_token": 0.000002,
            "input_image": 0.00153,
            "output_token": 0.000008
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "o3 is a well-rounded and powerful model across domains. It sets a new standard for math, science, coding, and visual reasoning tasks. It also excels at technical writing and instruction-following. Use it to think through multi-step problems that involve analysis across text, code, and images. Note that BYOK is required for this model. Set up here: https://openrouter.ai/settings/integrations",
            "releaseDate": "2025-04-16",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/o3-2025-04-16"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "tools",
                "tool_choice",
                "seed",
                "max_tokens",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/o3-pro": {
        "id": "openrouter:openai/o3-pro",
        "providerModelId": "openai/o3-pro",
        "name": "o3 Pro",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 200000,
            "maxCompletionTokens": 100000
        },
        "pricing": {
            "input_token": 0.00002,
            "input_image": 0.0153,
            "output_token": 0.00008
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "The o-series of models are trained with reinforcement learning to think before they answer and perform complex reasoning. The o3-pro model uses more compute to think harder and provide consistently better answers.\n\nNote that BYOK is required for this model. Set up here: https://openrouter.ai/settings/integrations",
            "releaseDate": "2025-06-10",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/o3-pro-2025-06-10"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "tools",
                "tool_choice",
                "seed",
                "max_tokens",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/o4-mini-high": {
        "id": "openrouter:openai/o4-mini-high",
        "providerModelId": "openai/o4-mini-high",
        "name": "o4 Mini High",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "image",
                "text",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "Other",
            "contextLength": 200000,
            "maxCompletionTokens": 100000
        },
        "pricing": {
            "input_token": 0.0000011,
            "input_image": 0.0008415,
            "output_token": 0.0000044
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": true
        },
        "metadata": {
            "description": "OpenAI o4-mini-high is the same model as [o4-mini](/openai/o4-mini) with reasoning_effort set to high. \n\nOpenAI o4-mini is a compact reasoning model in the o-series, optimized for fast, cost-efficient performance while retaining strong multimodal and agentic capabilities. It supports tool use and demonstrates competitive reasoning and coding performance across benchmarks like AIME (99.5% with Python) and SWE-bench, outperforming its predecessor o3-mini and even approaching o3 in some domains.\n\nDespite its smaller size, o4-mini exhibits high accuracy in STEM tasks, visual problem solving (e.g., MathVista, MMMU), and code editing. It is especially well-suited for high-throughput scenarios where latency or cost is critical. Thanks to its efficient architecture and refined reinforcement learning training, o4-mini can chain tools, generate structured outputs, and solve multi-step tasks with minimal delay—often in under a minute.",
            "releaseDate": "2025-04-16",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/o4-mini-high-2025-04-16"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "tools",
                "tool_choice",
                "seed",
                "max_tokens",
                "response_format",
                "structured_outputs"
            ],
            "modelParameters": []
        }
    },


    "openrouter:openai/gpt-5-nano": {
        "id": "openrouter:openai/gpt-5-nano",
        "providerModelId": "openai/gpt-5-nano",
        "name": " GPT-5 Nano",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 400000,
            "maxCompletionTokens": 128000
        },
        "pricing": {
            "input_token": 5e-8,
            "output_token": 4e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": false
        },
        "metadata": {
            "description": "GPT-5-Nano is the smallest and fastest variant in the GPT-5 system, optimized for developer tools, rapid interactions, and ultra-low latency environments. While limited in reasoning depth compared to its larger counterparts, it retains key instruction-following and safety features. It is the successor to GPT-4.1-nano and offers a lightweight option for cost-sensitive or real-time applications.",
            "releaseDate": "2025-08-07",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-5-nano-2025-08-07"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "include_reasoning",
                "max_tokens",
                "reasoning",
                "response_format",
                "seed",
                "structured_outputs",
                "tool_choice",
                "tools"
            ],
            "modelParameters": []
        }
    },

    "openrouter:openai/gpt-5-mini": {
        "id": "openrouter:openai/gpt-5-mini",
        "providerModelId": "openai/gpt-5-mini",
        "name": " GPT-5 Mini",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 400000,
            "maxCompletionTokens": 128000
        },
        "pricing": {
            "input_token": 2.5e-7,
            "output_token": 0.000002
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": false
        },
        "metadata": {
            "description": "GPT-5 Mini is a compact version of GPT-5, designed to handle lighter-weight reasoning tasks. It provides the same instruction-following and safety-tuning benefits as GPT-5, but with reduced latency and cost. GPT-5 Mini is the successor to OpenAI's o4-mini model.",
            "releaseDate": "2025-08-07",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-5-mini-2025-08-07"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "include_reasoning",
                "max_tokens",
                "reasoning",
                "response_format",
                "seed",
                "structured_outputs",
                "tool_choice",
                "tools"
            ],
            "modelParameters": []
        }
    },

    "openrouter:openai/gpt-5": {
        "id": "openrouter:openai/gpt-5",
        "providerModelId": "openai/gpt-5",
        "name": " GPT-5",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "GPT",
            "contextLength": 400000,
            "maxCompletionTokens": 128000
        },
        "pricing": {
            "input_token": 0.00000125,
            "output_token": 0.00001
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": true,
            "isCancellable": false
        },
        "metadata": {
            "description": "GPT-5 is OpenAI’s most advanced model, offering major improvements in reasoning, code quality, and user experience. It is optimized for complex tasks that require step-by-step reasoning, instruction following, and accuracy in high-stakes use cases. It supports test-time routing features and advanced prompt understanding, including user-specified intent like \"think hard about this.\" Improvements include reductions in hallucination, sycophancy, and better performance in coding, writing, and health-related tasks.\n\nNote that BYOK is required for this model. Set up here: https://openrouter.ai/settings/integrations",
            "releaseDate": "2025-08-07",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "openai/gpt-5-2025-08-07"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "include_reasoning",
                "max_tokens",
                "reasoning",
                "response_format",
                "seed",
                "structured_outputs",
                "tool_choice",
                "tools"
            ],
            "modelParameters": []
        }
    },

    "openrouter:openai/gpt-oss-20b": {
        "id": "openrouter:openai/gpt-oss-20b",
        "providerModelId": "openai/gpt-oss-20b",
        "name": " gpt-oss-20b",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text"
            ],
            "tokenizer": "GPT",
            "contextLength": 131072,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 4e-8,
            "output_token": 1.6e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "gpt-oss-20b is an open-weight 21B parameter model released by OpenAI under the Apache 2.0 license. It uses a Mixture-of-Experts (MoE) architecture with 3.6B active parameters per forward pass, optimized for lower-latency inference and deployability on consumer or single-GPU hardware. The model is trained in OpenAI’s Harmony response format and supports reasoning level configuration, fine-tuning, and agentic capabilities including function calling, tool use, and structured outputs.",
            "releaseDate": "2025-08-05",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "openai/gpt-oss-20b",
            "canonicalSlug": "openai/gpt-oss-20b"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "frequency_penalty",
                "include_reasoning",
                "logit_bias",
                "logprobs",
                "max_tokens",
                "min_p",
                "presence_penalty",
                "reasoning",
                "repetition_penalty",
                "response_format",
                "seed",
                "stop",
                "structured_outputs",
                "temperature",
                "tool_choice",
                "tools",
                "top_k",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },
    "openrouter:openai/gpt-oss-120b": {
        "id": "openrouter:openai/gpt-oss-120b",
        "providerModelId": "openai/gpt-oss-120b",
        "name": " gpt-oss-120b",
        "provider": "openrouter",
        "maker": "OpenAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text"
            ],
            "tokenizer": "GPT",
            "contextLength": 131072,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 7.256312e-8,
            "output_token": 2.903936e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "gpt-oss-120b is an open-weight, 117B-parameter Mixture-of-Experts (MoE) language model from OpenAI designed for high-reasoning, agentic, and general-purpose production use cases. It activates 5.1B parameters per forward pass and is optimized to run on a single H100 GPU with native MXFP4 quantization. The model supports configurable reasoning depth, full chain-of-thought access, and native tool use, including function calling, browsing, and structured output generation.",
            "releaseDate": "2025-08-05",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "openai/gpt-oss-120b",
            "canonicalSlug": "openai/gpt-oss-120b"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "frequency_penalty",
                "include_reasoning",
                "logit_bias",
                "logprobs",
                "max_tokens",
                "min_p",
                "presence_penalty",
                "reasoning",
                "repetition_penalty",
                "response_format",
                "seed",
                "stop",
                "structured_outputs",
                "temperature",
                "tool_choice",
                "tools",
                "top_k",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // META
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    "openrouter:meta-llama/llama-4-scout": {
        "id": "openrouter:meta-llama/llama-4-scout",
        "providerModelId": "meta-llama/llama-4-scout",
        "name": "Llama 4 Scout",
        "provider": "openrouter",
        "maker": "Meta",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Llama4",
            "contextLength": 1048576,
            "maxCompletionTokens": 1048576
        },
        "pricing": {
            "input_token": 8e-8,
            "output_token": 3e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Llama 4 Scout 17B Instruct (16E) is a mixture-of-experts (MoE) language model developed by Meta, activating 17 billion parameters out of a total of 109B. It supports native multimodal input (text and image) and multilingual output (text and code) across 12 supported languages. Designed for assistant-style interaction and visual reasoning, Scout uses 16 experts per forward pass and features a context length of 10 million tokens, with a training corpus of ~40 trillion tokens.\n\nBuilt for high efficiency and local or commercial deployment, Llama 4 Scout incorporates early fusion for seamless modality integration. It is instruction-tuned for use in multilingual chat, captioning, and image understanding tasks. Released under the Llama 4 Community License, it was last trained on data up to August 2024 and launched publicly on April 5, 2025.",
            "releaseDate": "2025-04-05",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "meta-llama/Llama-4-Scout-17B-16E-Instruct",
            "canonicalSlug": "meta-llama/llama-4-scout-17b-16e-instruct"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "structured_outputs",
                "response_format",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "seed",
                "top_k",
                "min_p",
                "repetition_penalty",
                "tools",
                "tool_choice",
                "top_logprobs",
                "logprobs",
                "logit_bias"
            ],
            "modelParameters": []
        }
    },
    "openrouter:meta-llama/llama-4-maverick": {
        "id": "openrouter:meta-llama/llama-4-maverick",
        "providerModelId": "meta-llama/llama-4-maverick",
        "name": "Llama 4 Maverick",
        "provider": "openrouter",
        "maker": "Meta",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text",
                "image"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text",
                "image",
                "vision"
            ],
            "tokenizer": "Llama4",
            "contextLength": 1048576,
            "maxCompletionTokens": 16384
        },
        "pricing": {
            "input_token": 1.5e-7,
            "input_image": 0.0006684,
            "output_token": 6e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Llama 4 Maverick 17B Instruct (128E) is a high-capacity multimodal language model from Meta, built on a mixture-of-experts (MoE) architecture with 128 experts and 17 billion active parameters per forward pass (400B total). It supports multilingual text and image input, and produces multilingual text and code output across 12 supported languages. Optimized for vision-language tasks, Maverick is instruction-tuned for assistant-like behavior, image reasoning, and general-purpose multimodal interaction.\n\nMaverick features early fusion for native multimodality and a 1 million token context window. It was trained on a curated mixture of public, licensed, and Meta-platform data, covering ~22 trillion tokens, with a knowledge cutoff in August 2024. Released on April 5, 2025 under the Llama 4 Community License, Maverick is suited for research and commercial applications requiring advanced multimodal understanding and high model throughput.",
            "releaseDate": "2025-04-05",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "meta-llama/Llama-4-Maverick-17B-128E-Instruct",
            "canonicalSlug": "meta-llama/llama-4-maverick-17b-128e-instruct"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "max_tokens",
                "temperature",
                "top_p",
                "stop",
                "frequency_penalty",
                "presence_penalty",
                "repetition_penalty",
                "response_format",
                "top_k",
                "seed",
                "min_p",
                "structured_outputs",
                "tools",
                "tool_choice",
                "logprobs",
                "top_logprobs",
                "logit_bias"
            ],
            "modelParameters": []
        }
    },


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // XAI
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "openrouter:x-ai/grok-3": {
        "id": "openrouter:x-ai/grok-3",
        "providerModelId": "x-ai/grok-3",
        "name": " Grok 3",
        "provider": "openrouter",
        "maker": "xAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text"
            ],
            "tokenizer": "Grok",
            "contextLength": 131072,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 0.000003,
            "output_token": 0.000015
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Grok 3 is the latest model from xAI. It's their flagship model that excels at enterprise use cases like data extraction, coding, and text summarization. Possesses deep domain knowledge in finance, healthcare, law, and science.\n\n",
            "releaseDate": "2025-06-10",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "x-ai/grok-3"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "frequency_penalty",
                "logprobs",
                "max_tokens",
                "presence_penalty",
                "response_format",
                "seed",
                "stop",
                "structured_outputs",
                "temperature",
                "tool_choice",
                "tools",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },

    "openrouter:x-ai/grok-4": {
        "id": "openrouter:x-ai/grok-4",
        "providerModelId": "x-ai/grok-4",
        "name": " Grok 4",
        "provider": "openrouter",
        "maker": "xAI",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "image",
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "image",
                "text",
                "vision"
            ],
            "tokenizer": "Grok",
            "contextLength": 256000,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 0.000003,
            "output_token": 0.000015
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Grok 4 is xAI's latest reasoning model with a 256k context window. It supports parallel tool calling, structured outputs, and both image and text inputs. Note that reasoning is not exposed, reasoning cannot be disabled, and the reasoning effort cannot be specified. Pricing increases once the total tokens in a given request is greater than 128k tokens. See more details on the [xAI docs](https://docs.x.ai/docs/models/grok-4-0709)",
            "releaseDate": "2025-07-09",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "canonicalSlug": "x-ai/grok-4-07-09"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "include_reasoning",
                "logprobs",
                "max_tokens",
                "reasoning",
                "response_format",
                "seed",
                "structured_outputs",
                "temperature",
                "tool_choice",
                "tools",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },


    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Qwen
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    "openrouter:qwen/qwen3-coder": {
        "id": "openrouter:qwen/qwen3-coder",
        "providerModelId": "qwen/qwen3-coder",
        "name": " Qwen3 Coder ",
        "provider": "openrouter",
        "maker": "Qwen",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text"
            ],
            "tokenizer": "Qwen3",
            "contextLength": 262144,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 2e-7,
            "output_token": 8e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Qwen3-Coder-480B-A35B-Instruct is a Mixture-of-Experts (MoE) code generation model developed by the Qwen team. It is optimized for agentic coding tasks such as function calling, tool use, and long-context reasoning over repositories. The model features 480 billion total parameters, with 35 billion active per forward pass (8 out of 160 experts).\n\nPricing for the Alibaba endpoints varies by context length. Once a request is greater than 128k input tokens, the higher pricing is used.",
            "releaseDate": "2025-07-23",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "Qwen/Qwen3-Coder-480B-A35B-Instruct",
            "canonicalSlug": "qwen/qwen3-coder-480b-a35b-07-25"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "frequency_penalty",
                "logit_bias",
                "logprobs",
                "max_tokens",
                "min_p",
                "presence_penalty",
                "repetition_penalty",
                "response_format",
                "seed",
                "stop",
                "structured_outputs",
                "temperature",
                "tool_choice",
                "tools",
                "top_k",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },
    "openrouter:qwen/qwen3-235b-a22b-thinking-2507": {
        "id": "openrouter:qwen/qwen3-235b-a22b-thinking-2507",
        "providerModelId": "qwen/qwen3-235b-a22b-thinking-2507",
        "name": " Qwen3 235B",
        "provider": "openrouter",
        "maker": "Qwen",
        "active": true,
        "status": "active",
        "architecture": {
            "inputModalities": [
                "text"
            ],
            "outputModalities": [
                "text"
            ],
            "capabilities": [
                "text"
            ],
            "tokenizer": "Qwen3",
            "contextLength": 262144,
            "maxCompletionTokens": null
        },
        "pricing": {
            "input_token": 7.7968332e-8,
            "output_token": 3.1202496e-7
        },
        "capabilities": {
            "isReasoningModel": false,
            "isModerated": false,
            "isCancellable": false
        },
        "metadata": {
            "description": "Qwen3-235B-A22B-Thinking-2507 is a high-performance, open-weight Mixture-of-Experts (MoE) language model optimized for complex reasoning tasks. It activates 22B of its 235B parameters per forward pass and natively supports up to 262,144 tokens of context. This \"thinking-only\" variant enhances structured logical reasoning, mathematics, science, and long-form generation, showing strong benchmark performance across AIME, SuperGPQA, LiveCodeBench, and MMLU-Redux. It enforces a special reasoning mode (</think>) and is designed for high-token outputs (up to 81,920 tokens) in challenging domains.\n\nThe model is instruction-tuned and excels at step-by-step reasoning, tool use, agentic workflows, and multilingual tasks. This release represents the most capable open-source variant in the Qwen3-235B series, surpassing many closed models in structured reasoning use cases.",
            "releaseDate": "2025-07-25",
            "knowledgeCutoff": null,
            "website": null,
            "keywords": [],
            "huggingFaceId": "Qwen/Qwen3-235B-A22B-Thinking-2507",
            "canonicalSlug": "qwen/qwen3-235b-a22b-thinking-2507"
        },
        "parameters": {
            "openrouterSupportedParameters": [
                "frequency_penalty",
                "include_reasoning",
                "logit_bias",
                "logprobs",
                "max_tokens",
                "min_p",
                "presence_penalty",
                "reasoning",
                "repetition_penalty",
                "response_format",
                "seed",
                "stop",
                "temperature",
                "tool_choice",
                "tools",
                "top_k",
                "top_logprobs",
                "top_p"
            ],
            "modelParameters": []
        }
    },


}







export const MODEL_IDS = [
    // Perplexity
    "perplexity/sonar",
    "perplexity/sonar-pro",
    "perplexity/sonar-reasoning-pro",

    // Anthropic
    "openrouter:anthropic/claude-sonnet-4",
    "openrouter:anthropic/claude-opus-4",

    // Google
    "openrouter:google/gemini-2.0-flash-001",
    "openrouter:google/gemini-2.5-flash-lite",
    "openrouter:google/gemini-2.5-flash",
    "openrouter:google/gemini-2.5-pro",
    "fal-ai/imagen4/preview",
    "fal-ai/flux-pro/kontext/max",

    // OpenAI
    "openrouter:openai/gpt-4.1-nano",
    "openrouter:openai/gpt-4.1-mini",
    "openrouter:openai/gpt-4.1",
    "openrouter:openai/gpt-4o",
    "openrouter:openai/o3",
    "openrouter:openai/o3-pro",
    "openrouter:openai/o4-mini-high",
    "openrouter:openai/gpt-5-nano",
    "openrouter:openai/gpt-5-mini",
    "openrouter:openai/gpt-5",
    "openrouter:openai/gpt-oss-20b",
    "openrouter:openai/gpt-oss-120b",

    // Meta
    "openrouter:meta-llama/llama-4-scout",
    "openrouter:meta-llama/llama-4-maverick",

    // XAI
    "openrouter:x-ai/grok-3",
    "openrouter:x-ai/grok-4",

    // Qwen
    "openrouter:qwen/qwen3-coder",
    "openrouter:qwen/qwen3-235b-a22b-thinking-2507",




] as const

export type ModelId = typeof MODEL_IDS[number]

export const defaulTextModel = "openrouter:google/gemini-2.5-flash-lite"